import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import "../App.css";

const useStyles = makeStyles(theme => ({

    loaderHolder: {
        background: theme.palette.background.paper + '85',
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        top: 0,
        left: 0,
        zIndex: 2,
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },

    progress: {
        margin: theme.spacing(2),
        color: theme.primary
    },

}));

const Loader = () => {
    const classes = useStyles();
    return (
        <div className={classes.loaderHolder}>
            <CircularProgress className={classes.progress} />
        </div>
    )
};
export default Loader;